<template>
  <div class="form-group"
       v-bind:class="{'disabled': disabled, 'position-md-relative': positionAbsolute}">
    <label v-bind:for="id" v-if="firstLabel && !modeRange" class="form-label">{{ firstLabel }}
      <i v-if="required" class="far fa-asterisk"></i>
    </label>
    <div v-click-outside="close" v-bind:class="{'is-invalid': invalid}">
      <template v-if="renderInput">
        <div v-if="modeMultiple"
             v-on:click="open()"
             v-bind:style="inputStyle"
             v-bind:class="singleInputClass">
          <template v-if="formattedValue && formattedValue.length > 0">
            <span v-for="(date, dateIndex) in formattedValue" v-bind:key="'date' + dateIndex">
              <i v-if="dateIndex > 0" style="transform: rotate(90deg);" class="fal fa-horizontal-rule"></i>
              {{ date }}
            </span>
          </template>
          <span v-else-if="placeholder" class="text-muted">
            {{ placeholder }}
          </span>
          <i style="opacity: 0;">#</i>
        </div>
        <div v-else-if="modeRange" class="row align-items-end">
          <div class="col-12 col-sm mb-2 mb-sm-0">
            <label v-bind:for="id + ':from'" v-if="firstLabel" class="form-label">{{ firstLabel }}
              <i v-if="required" class="far fa-asterisk"></i>
            </label>
            <input v-bind:id="id + ':from'"
                   type="text"
                   ref="from"
                   v-model="formattedRangeValueFrom"
                   v-bind:placeholder="firstPlaceholder"
                   v-on:click="open('from')"
                   v-on:focus="rangeFromFocus = true; rangeToFocus = false;"
                   v-bind:style="inputStyle"
                   v-bind:class="fromInputClass"
                   v-bind:disabled="disabled"
                   v-bind:readonly="readonly"
                   autocomplete="off"/>
            <!--
            TODO: select a 'from' year, month or week?
            -->
          </div>
          <div class="d-none d-sm-block col-sm-auto">
            <div style="border-color: transparent !important;" class="form-control bg-transparent px-0">
              <i class="fal fa-arrow-right"></i>
            </div>
          </div>
          <div class="col-12 col-sm">
            <label v-bind:for="id + ':to'" v-if="secondLabel" class="form-label">{{ secondLabel }}
              <i v-if="required" class="far fa-asterisk"></i>
            </label>
            <input v-bind:id="id + ':to'"
                   type="text"
                   ref="to"
                   v-model="formattedRangeValueTo"
                   v-bind:placeholder="secondPlaceholder"
                   v-on:click="open('to')"
                   v-on:focus="rangeFromFocus = false; rangeToFocus = true;"
                   v-bind:style="inputStyle"
                   v-bind:class="toInputClass"
                   v-bind:disabled="disabled"
                   v-bind:readonly="readonly"
                   autocomplete="off"/>
            <!--
            TODO: select a 'to' year, month or week?
            -->
          </div>
        </div>
        <input v-else-if="modeYear || modeMonth || modeWeek || modeDate || modeDatetime"
               v-bind:id="id"
               type="text"
               v-model="formattedValue"
               v-bind:placeholder="placeholder"
               v-on:click="open()"
               v-bind:style="inputStyle"
               v-bind:class="singleInputClass"
               v-bind:disabled="disabled"
               v-bind:readonly="readonly"
               autocomplete="off"/>
      </template>
      <button v-if="renderButton"
              v-on:click.prevent="open()"
              v-bind:style="buttonStyle"
              v-bind:class="buttonClass">
        {{ modeDate || modeDatetime ? bundle.id_10780 : bundle.id_10067 }}
      </button>
      <transition name="slide-fade-from-corner">
        <div v-bind:style="(positionAbsolute ? 'left: 0; position: absolute; z-index: 2;' : '') + ('width: ' + width + ';')"
             class="w-100-lt-md">
          <div v-if="positionRelative || isOpen"
               v-bind:class="{'card shadow mx-2': positionAbsolute}">
            <div v-bind:class="{'card-body': positionAbsolute}">
              <div class="row align-items-center">
                <div class="col">
                  <div class="row text-center mb-3" v-bind:class="{'mt-3': positionRelative}">
                    <div class="col-auto">
                      <button v-on:click.prevent="previous()" class="btn btn-text"><i class="fal fa-chevron-left"></i>
                      </button>
                    </div>
                    <div class="col">
                      <button v-if="pickWeek || pickDate" v-on:click.prevent="active.month = null" class="btn btn-text">
                        <b>
                          <template v-if="months[active.month - 1]">{{ months[active.month - 1].name }}</template>
                          {{ active.year }}
                        </b>
                      </button>
                      <button v-else-if="pickMonth" class="btn btn-text" v-on:click.prevent="active.year = null, active.month = null">
                        <b>{{ active.year }}</b></button>
                    </div>
                    <div class="col-auto">
                      <button v-on:click.prevent="next()" class="btn btn-text"><i class="fal fa-chevron-right"></i>
                      </button>
                    </div>
                  </div>
                  <div class="text-center mb-3">
                    <table v-if="pickDate" class="w-100">
                      <thead class="text-muted">
                      <tr>
                        <td v-if="showWeeks"></td>
                        <td v-for="(weekday, weekdayIndex) in weekdays" v-bind:key="'weekday' + weekdayIndex"
                            v-bind:title="weekday.name">
                          <b>{{ weekday.abbreviation }}</b>
                        </td>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(week, weekIndex) in weeks" v-bind:key="'week' + weekIndex">
                        <td v-if="showWeeks" class="text-start text-muted pe-3"><small>{{ week.week }}</small></td>
                        <td v-for="(weekday, weekdayIndex) in week.weekdays" v-bind:key="'weekday' + weekdayIndex"
                            style="position: relative;">
                          <button v-if="weekday.active || showAdjacentMonths"
                                  v-on:click.prevent="weekday.unselectable && !weekday.picked ? showUnselectableReason() : weekday.previous ? previous() : weekday.next ? next() : pick(weekday.year, weekday.month, weekday.date)"
                                  style="border-radius: 50% !important; width: 2rem !important; height: 2rem !important;"
                                  v-bind:style="(weekday.active && !weekday.disabled ? '' : 'opacity: 0.25;') + (weekday.unselectable && !weekday.picked ? 'text-decoration: line-through;' : '') + (weekday.events == true ? 'font-weight: 900;' : '')"
                                  class="p-1 mb-2 btn"
                                  v-bind:class="{'btn-primary': weekday.picked, 'btn-outline-primary': !weekday.picked && weekday.current && showCurrent, 'btn-text': !weekday.picked && !weekday.current}"
                                  v-bind:disabled="weekday.disabled">{{ weekday.date }}
                          </button>
                          <span v-if="weekday.events && weekday.events.length"
                                style="position: absolute; text-align: center; width: 100%; left: 0; bottom: 0.25rem; height: 0.5rem; line-height: 0;">
                            <span v-for="(event, eventIndex) in weekday.events"
                                  v-bind:key="'event' + eventIndex"
                                  style="width: 0.5rem; height: 0.5rem; display: inline-block; border-radius: 50%; margin: 0 0.0625rem 0.0625rem 0.0625rem;"
                                  v-bind:style="'background-color: ' + event + ';'"/>
                          </span>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <div v-else-if="pickWeek" class="row">
                      <div class="col">
                        <div v-for="(week, weekIndex) in weeks" v-bind:key="'week' + weekIndex">
                          <button v-on:click.prevent="pick(week.weekdays[0].year, week.weekdays[0].month, week.weekdays[0].date)"
                                  class="btn w-100"
                                  v-bind:class="{'btn-primary': modeWeek && isPicked(week.weekdays[0].year, week.weekdays[0].month, week.weekdays[0].date), 'btn-text': !modeWeek || !isPicked(week.weekdays[0].year, week.weekdays[0].month, week.weekdays[0].date)}">
                            <strong>{{ bundle.id_12017.replace('{0}', week.week) }}</strong>
                            <small class="d-block">
                              <formatted-date v-bind:value="week.weekdays[0].dateTime" v-bind:format="dateFormat" v-bind:locale="locale"/>
                              <i class="fal fa-arrow-right mx-1"></i>
                              <formatted-date v-bind:value="week.weekdays[week.weekdays.length - 1].dateTime" v-bind:format="dateFormat" v-bind:locale="locale"/>
                            </small>
                          </button>
                          <!--
                          TODO: implement disabled, unselectable and events on week level
                          -->
                        </div>
                      </div>
                    </div>
                    <div v-else-if="pickMonth" class="row">
                      <div v-for="(col, colIndex) in toCols(2, months)" v-bind:key="'col' + colIndex" class="col-6">
                        <button v-for="(month, monthIndex) in col" v-bind:key="'month' + monthIndex"
                                v-on:click.prevent="modeMonth ? pick(active.year, month.number, 1) : active.month = month.number"
                                class="btn w-100"
                                v-bind:class="{'btn-primary': modeMonth && isPicked(active.year, month.number, 1), 'btn-text': !modeMonth || !isPicked(active.year, month.number, 1)}">{{ month.name }}
                        </button><br/>
                        <!--
                        TODO: implement disabled, unselectable and events on months level
                        -->
                      </div>
                    </div>
                    <div v-else-if="pickYear" class="row">
                      <div v-for="(col, colIndex) in toCols(3, years)" v-bind:key="'col' + colIndex" class="col-4">
                        <button v-for="(year, yearIndex) in col" v-bind:key="'year' + yearIndex"
                                v-on:click.prevent="modeYear ? pick(year, 1, 1) : active.year = year"
                                class="btn w-100"
                                v-bind:class="{'btn-primary': modeYear && isPicked(year, 1, 1), 'btn-text': !modeYear || !isPicked(year, 1, 1)}">{{ year }}
                        </button><br/>
                        <!--
                        TODO: implement disabled, unselectable and events on year level
                        -->
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="modeDatetime" class="col d-flex">
                  <table style="width: 0; font-size: 2rem; line-height: 1rem;"
                         class="text-center mx-auto align-self-center">
                    <thead>
                    <tr>
                      <td style="width: 50%;">
                        <button v-on:click.prevent="hoursUp()" style="font-size: 2rem; line-height: 1rem;"
                                class="btn btn-text"><i class="fal fa-chevron-up"></i></button>
                      </td>
                      <td style="width: 0;"></td>
                      <td style="width: 50%;">
                        <button v-on:click.prevent="minutesUp()" style="font-size: 2rem; line-height: 1rem;"
                                class="btn btn-text"><i class="fal fa-chevron-up"></i></button>
                      </td>
                      <td v-if="hourFormat == 12"></td>
                    </tr>
                    </thead>
                    <tfoot>
                    <tr>
                      <td>
                        <button v-on:click.prevent="hoursDown()" style="font-size: 2rem; line-height: 1rem;"
                                class="btn btn-text"><i class="fal fa-chevron-down"></i></button>
                      </td>
                      <td></td>
                      <td>
                        <button v-on:click.prevent="minutesDown()" style="font-size: 2rem; line-height: 1rem;"
                                class="btn btn-text"><i class="fal fa-chevron-down"></i></button>
                      </td>
                      <td v-if="hourFormat == 12"></td>
                    </tr>
                    </tfoot>
                    <tbody>
                    <tr>
                      <td>
                        <select v-model="internalHourValue" style="font-size: 2rem; min-width: 5rem;"
                                class="form-control border-0 text-center">
                          <option v-for="hour in hourFormat" v-bind:key="'hour' + hour"
                                  v-bind:value="hourFormat == 12 ? hour : hour - 1">
                            {{ zeroPad(hourFormat == 12 ? hour : hour - 1, 2) }}
                          </option>
                        </select>
                      </td>
                      <td>:</td>
                      <td>
                        <select v-model="internalMinuteValue" style="font-size: 2rem; min-width: 5rem;"
                                class="form-control border-0 text-center">
                          <option v-for="minute in 60" v-bind:key="'minute' + minute" v-bind:value="minute - 1">
                            {{ zeroPad(minute - 1, 2) }}
                          </option>
                        </select>
                      </td>
                      <td v-if="hourFormat == 12">
                        <button v-on:click.prevent="toggleAmPm()" style="font-size: 2rem; min-width: 5rem;"
                                class="btn btn-text">{{ am ? 'AM' : 'PM' }}
                        </button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div v-if="immediate && positionAbsolute" class="text-end mt-3">
                <button v-on:click.prevent="close()" class="btn btn-outline-primary ms-2">{{ bundle.id_9822 }}</button>
              </div>
              <div v-else-if="positionAbsolute" class="text-end mt-3">
                <button v-on:click.prevent="ok()" class="btn btn-primary">{{ bundle.id_9221 }}</button>
                <button v-on:click.prevent="close()" class="btn btn-outline-primary ms-2">{{ bundle.id_9108 }}</button>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <local-errors v-bind:value="errors"/>
    <div v-if="help" class="form-text">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import FormattedDate from "../components/formatted-date";
import DatetimeUtil from "../plugins/datetime-util";
import Util from "../plugins/util";
import {DateTime, Info} from "luxon";

Vue.use(DatetimeUtil);
Vue.use(Util);

export default {
  name: "input-date",
  components: {
    FormattedDate
  },
  props: {
    id: {
      type: String,
      required: true
    },
    /**
     * The value must be an array of Dates or a single Date. You can use an object as value, but only if you provide
     * convert-input and convert-output functions that convert the object to and from an array of Dates or a single
     * Date.
     */
    value: {
      type: [Array, Date, Object],
      // validator: function (value) {
      //   if (value && Array.isArray(value)) {
      //     for (var i = 0; i < value.length; i++) {
      //       var v = value[i];
      //       if (v && !(v instanceof Date)) {
      //         return false;
      //       }
      //     }
      //   }
      //   return true;
      // }
    },
    errors: {
      type: Array
    },
    /**
     * The label as a string or if "mode" is set to "range" you can provide an array with two label strings. One for
     * the "from" date and another for the "to".
     */
    label: {
      type: [String, Array],
      validator: function (value) {
        if (value && Array.isArray(value)) {
          for (var i = 0; i < value.length; i++) {
            var v = value[i];
            if (v && typeof v != "string") {
              return false;
            }
          }
        }
        return true;
      }
    },
    placeholder: {
      type: [String, Array],
      validator: function (value) {
        if (value && Array.isArray(value)) {
          for (var i = 0; i < value.length; i++) {
            var v = value[i];
            if (v && typeof v != "string") {
              return false;
            }
          }
        }
        return true;
      }
    },
    /**
     * Mode can be "year", "month", "week", "date", "datetime", "range" (array with max length 2) or "multiple" (array). Default is "date".
     */
    mode: {
      type: String,
      default: "date",
      validator: function (value) {
        return ["year", "month", "week", "date", "datetime", "range", "multiple"].indexOf(value) !== -1
      }
    },
    /**
     * Values range from 1 to 7 for Mon to Sun. Default 1 is Mon.
     * NOTE: We are using Luxon and Luxon does not support setting first weekday at the moment. So this function
     * doesn't really work as intended. Default first weekday in Luxon is Monday.
     */
    firstWeekday: {
      type: Number,
      default: 1,
      validator: function (value) {
        return value >= 1 && value <= 7;
      }
    },
    /**
     * Use 12-hour or 24-hour format. Default is 24-hour format.
     */
    hourFormat: {
      type: Number,
      default: 24,
      validator: function (value) {
        return [12, 24].indexOf(value) !== -1;
      }
    },
    /**
     * A function that takes a value (the v-model value) and returns it as a Date or array of Dates that this component can use.
     */
    convertInput: {
      type: Function
    },
    /**
     * A function that takes a Date or array of Dates and returns a value (the v-model value).
     */
    convertOutput: {
      type: Function
    },
    /**
     * Supports Luxon tokens (https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
     */
    inputFormat: {
      type: String,
      default: "yyyy-MM-dd HH:mm"
    },
    /**
     * Supports Luxon tokens (https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
     */
    dateFormat: {
      type: String,
      default: "yyyy-MM-dd"
    },
    /**
     * Supports Luxon tokens (https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
     */
    timeFormat: {
      type: String,
      default: "HH:mm"
    },
    /**
     * Converts a date to a string using the formats specified. If you override this function you either need to
     * implement your own format conversion or a solution that does not rely on the specified formats.
     */
    getAsString: {
      type: Function,
      default: function (date) {
        return Vue.$datetimeUtil.getAsString(date, this.inputFormat, this.datetimeUtilOptions);
      }
    },
    /**
     * Converts a string to a date using the formats specified. If you override this function you either need to
     * implement your own format conversion or a solution that does not rely on the specified formats.
     */
    getAsDate: {
      type: Function,
      default: function (str) {
        return Vue.$datetimeUtil.getAsDate(str, this.inputFormat, this.datetimeUtilOptions);
      }
    },
    /**
     * If true, value is set immediately; otherwise value is set only when you click "ok". Default is true.
     */
    immediate: {
      type: Boolean,
      default: true
    },
    /**
     * A function that takes a date object and a second object with some extra information and returns true if that date should be disabled and false if not.
     */
    disabledDate: {
      type: Function
    },
    /**
     * A function that takes a date object and a second object with some extra information and returns true if that date should be unselectable and false if not.
     */
    unselectableDate: {
      type: Function
    },
    /**
     * If set with a String, that String is shown if you try to select one of the unselectable dates and it should give you the reason why it is unselectable.
     */
    unselectableReason: {
      type: String
    },
    /**
     * Specify either "date", "month" or "year" to initially show the picker for date, month or year. Default is "date".
     */
    initialPicker: {
      type: String,
      default: "date",
      validator: function (value) {
        return ["year", "month", "week", "date"].indexOf(value) !== -1
      }
    },
    /**
     * A function that takes a Date and an object with date information. The function should return an array with
     * color codes of events on the given date, or simply return true or false to mark the date in bold or not.
     */
    events: {
      type: Function
    },
    required: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    /**
     * Maximum width of the picker area as a string. For example "800px" or "100%". Default is "400px".
     */
    width: {
      type: String,
      default: "400px"
    },
    /**
     * Show the current date in the calendar. Default is true.
     */
    showCurrent: {
      type: Boolean,
      default: true
    },
    /**
     * Show adjacent months in the calendar. Default is false.
     */
    showAdjacentMonths: {
      type: Boolean,
      default: false
    },
    /**
     * Show week numbers in the calendar. Default is true.
     */
    showWeeks: {
      type: Boolean,
      default: true
    },
    /**
     * How should the component render? Supported values are "button" and "input". Default is "input".
     */
    render: {
      type: String,
      default: "input",
      validator: function (value) {
        return ["button", "input", "nothing"].indexOf(value) !== -1
      }
    },
    buttonStyle: {
      type: String
    },
    buttonClass: {
      type: String,
      default: "btn btn-primary"
    },
    inputStyle: {
      type: String
    },
    inputClass: {
      type: String,
      default: "form-control"
    },
    readonly: {
      type: Boolean,
      default: false
    },
    /**
     * Position of the calendar area. Supported values are "absolute" or "relative". If "absolute" the calendar
     * will lay above the rest of the content. If "relative" the calendar is always shown as an integrated part
     * of the page. Default is "absolute".
     */
    position: {
      type: String,
      default: "absolute",
      validator: function (value) {
        return ["absolute", "relative"].indexOf(value) !== -1
      }
    },
    locale: {
      type: String,
      default: "en"
    }
  },
  data: function () {
    var current = DateTime.now();
    var initialYear = this.initialPicker == "year" || this.mode == "year";
    var initialMonth = initialYear || this.initialPicker == "month" || this.mode == "month";
    return {
      bundle: {
        id_10780: "Select Date",
        id_10067: "Select Dates",
        id_9822: "Done",
        id_9108: "Cancel",
        id_9221: "OK",
        id_12017: "Week {0}"
      },
      // Just today's date
      current: {
        year: current.year,
        month: current.month,
        date: current.day,
      },
      // The year and month shown in the calendar
      active: {
        year: initialYear ? null : current.year,
        month: initialMonth ? null : current.month
      },
      picked: null,
      paginationYear: current.year,
      paginationYearSize: 36,
      yearMin: 1000,
      yearMax: 9999,
      isOpen: false,
      rangeFromFocus: false,
      rangeToFocus: false,
    }
  },
  mounted() {
    // prevent click outside event with popupItem.
    this.popupItem = this.$el;
  },
  created: function () {
    var instance = this;
    Vue.$bundle("portal", instance.bundle, function (bundle) {
      instance.bundle = bundle;
    });
    document.addEventListener("keydown", instance.keydownListener);
  },
  destroyed: function () {
    document.removeEventListener("keydown", this.keydownListener);
  },
  computed: {
    convertedValue: {
      get: function () {
        var value = this.value;
        if (this.convertInput) {
          value = this.convertInput(value);
        }
        return value;
      },
      set: function (newValue) {
        var value = newValue;
        if (this.convertOutput) {
          value = this.convertOutput(value);
        }
        this.$emit("input", value);
      }
    },
    formattedValue: {
      get: function () {
        if (this.modeMultiple || this.modeRange) {
          var array = [];
          if (Array.isArray(this.internalValue)) {
            for (var i = 0; i < this.internalValue.length; i++) {
              array.push(this.getAsString(this.internalValue[i]));
            }
          }
          return array;
        }
        return this.getAsString(this.internalValue);
      },
      set: function (newValue) {
        if (newValue && !this.isValidStringDate(newValue)) {
          return;
        }
        var value = newValue ? this.getAsDate(newValue) : null;
        if (this.immediate) {
          this.convertedValue = value;
        } else {
          this.internalValue = value;
        }
        if (value) {
          this.setActive(value.year, value.month);
        }
      }
    },
    formattedRangeValueFrom: {
      get: function () {
        return this.formattedValue[0];
      },
      set: function (newValue) {
        if (newValue && !this.isValidStringDate(newValue)) {
          return;
        }
        var value = newValue ? this.getAsDate(newValue) : null;
        var other = this.internalValue && Array.isArray(this.internalValue) ? this.internalValue[1] : null;
        if (Vue.$datetimeUtil.isAfterDate(value, other)) {
          this.reversedFocus();
        }
        var array = [value, other];
        array.sort(Vue.$datetimeUtil.compareDates);
        if (this.immediate) {
          this.convertedValue = array;
        } else {
          this.internalValue = array;
        }
        if (value) {
          this.setActive(value.year, value.month);
        }
      }
    },
    formattedRangeValueTo: {
      get: function () {
        return this.formattedValue[1];
      },
      set: function (newValue) {
        if (newValue && !this.isValidStringDate(newValue)) {
          return;
        }
        var other = this.internalValue && Array.isArray(this.internalValue) ? this.internalValue[0] : null;
        var value = newValue ? this.getAsDate(newValue) : null;
        if (Vue.$datetimeUtil.isAfterDate(other, value)) {
          this.reversedFocus();
        }
        var array = [other, value];
        array.sort(Vue.$datetimeUtil.compareDates);
        if (this.immediate) {
          this.convertedValue = array;
        } else {
          this.internalValue = array;
        }
        if (value) {
          this.setActive(value.year, value.month);
        }
      }
    },
    internalValue: {
      get: function () {
        if (this.immediate || this.positionRelative) {
          return this.convertedValue;
        } else {
          return this.picked;
        }
      },
      set: function (newValue) {
        if (this.immediate || this.positionRelative) {
          this.convertedValue = newValue;
        } else {
          this.picked = newValue;
        }
      }
    },
    internalHourValue: {
      get: function () {
        var value = this.internalValue && this.internalValue instanceof Date ? this.internalValue.hour : 0;
        return this.formatHour(value);
      },
      set: function (newValue) {
        if (this.internalValue && this.internalValue instanceof Date && this.validHours(newValue)) {
          var newDate = this.copyDate(this.internalValue);
          newDate.setHours(this.unFormatHour(newValue));
          this.internalValue = newDate;
        }
      }
    },
    internalMinuteValue: {
      get: function () {
        return this.internalValue && this.internalValue instanceof Date ? this.internalValue.minute : 0;
      },
      set: function (newValue) {
        if (this.internalValue && this.internalValue instanceof Date && this.validMinutes(newValue)) {
          var newDate = this.copyDate(this.internalValue);
          newDate.setMinutes(newValue);
          this.internalValue = newDate;
        }
      }
    },
    valueMap: function () {
      if (this.internalValue) {
        return Vue.$util.mapArrayOfUniqueObjects(Array.isArray(this.internalValue) ? this.internalValue : [this.internalValue], [
            "year",
            "month",
            "day"
        ]);
      }
      return {};
    },
    help: function () {
      return !!this.$slots.default;
    },
    invalid: function () {
      return this.errors && this.errors.length > 0;
    },
    modeMultiple: function () {
      return this.mode == "multiple";
    },
    modeRange: function () {
      return this.mode == "range";
    },
    modeYear: function () {
      return this.mode == "year";
    },
    modeMonth: function () {
      return this.mode == "month";
    },
    modeWeek: function () {
      return this.mode == "week";
    },
    modeDate: function () {
      return this.mode == "date";
    },
    modeDatetime: function () {
      return this.mode == "datetime";
    },
    // modeTime: function () {
    //   return this.mode == "time";
    // },
    years: function () {
      var years = [];
      var first = this.paginationYear - this.paginationYearSizeBefore;
      if (first < this.yearMin) {
        first = this.yearMin;
      }
      for (var year = first; year < first + this.paginationYearSize && year <= this.yearMax; year++) {
        years.push(year);
      }
      return years;
    },
    weeks: function () {
      var instance = this;
      var weeks = [];

      var previousMonth = DateTime.local(instance.active.year, instance.active.month, 1).plus({months: -1});
      var previousNumberOfDatesInMonth = instance.getLastDateOfMonth(previousMonth.year, previousMonth.month);

      var nextMonth = DateTime.local(instance.active.year, instance.active.month, 1).plus({months: 1});
      var nextMonthDate = 1;

      var activeMonthDate = 1;
      var activeMonthFirstWeekdayNumber = Vue.$datetimeUtil.getWeekday(instance.active.year, instance.active.month, activeMonthDate, instance.firstWeekday);
      // var activeMonthFirstWeekdayNumber = DateTime.local(instance.active.year, instance.active.month, activeMonthDate).weekday;
      // var activeMonthFirstWeekdayNumber = instance.getFirstWeekdayOfMonth(instance.active.year, instance.active.month);
      var activeNumberOfDatesInMonth = instance.getLastDateOfMonth(instance.active.year, instance.active.month);
      var activeMonthWeekNumbers = instance.getWeeksInMonth(instance.active.year, instance.active.month);

      var previousMonthDate = previousNumberOfDatesInMonth - activeMonthFirstWeekdayNumber + 2;

      var phase = "previous";
      // Add all weeks in the current month.
      for (var weekIndex = 0; weekIndex < activeMonthWeekNumbers.length; weekIndex++) {
        var weekNumber = activeMonthWeekNumbers[weekIndex];
        var week = {
          week: weekNumber > 0 ? weekNumber : Vue.$datetimeUtil.getWeekNumber(instance.active.year - 1, 12, 31, instance.firstWeekday),
          weekdays: []
        }
        for (var weekdayIndex = 0; weekdayIndex < instance.weekdays.length; weekdayIndex++) {
          var weekday = instance.weekdays[weekdayIndex];
          var obj = {
            weekday: weekday
          };
          if (phase == "previous") {
            phase = activeMonthFirstWeekdayNumber == weekday.number ? "active" : "previous";
          } else if (phase == "active") {
            phase = activeMonthDate <= activeNumberOfDatesInMonth ? "active" : "next";
          }
          switch (phase) {
            case "previous":
              obj.date = previousMonthDate;
              obj.month = previousMonth.month;
              obj.year = previousMonth.year;
              obj.previous = true;
              obj.active = false;
              obj.next = false;
              previousMonthDate++;
              break;
            case "active":
              obj.date = activeMonthDate;
              obj.month = instance.active.month;
              obj.year = instance.active.year;
              obj.previous = false;
              obj.active = true;
              obj.next = false;
              activeMonthDate++;
              break;
            case "next":
              obj.date = nextMonthDate;
              obj.month = nextMonth.month;
              obj.year = nextMonth.year;
              obj.previous = false;
              obj.active = false;
              obj.next = true;
              nextMonthDate++;
              break;
          }
          var dateTime = DateTime.local(obj.year, obj.month, obj.date);
          obj.dateTime = dateTime;
          obj.picked = instance.isPicked(obj.year, obj.month, obj.date);
          obj.current = Vue.$datetimeUtil.isSameDate(
              DateTime.local(instance.current.year, instance.current.month, instance.current.date),
              dateTime);
          if (instance.disabledDate) {
            obj.disabled = instance.disabledDate(
                dateTime,
                instance.createCallbackObject(obj.year, obj.month, obj.date, week.week, weekday.number, obj.picked));
          }
          if (instance.unselectableDate) {
            obj.unselectable = instance.unselectableDate(
                dateTime,
                instance.createCallbackObject(obj.year, obj.month, obj.date, week.week, weekday.number, obj.picked));
          }
          if (instance.events) {
            obj.events = instance.events(
                dateTime,
                instance.createCallbackObject(obj.year, obj.month, obj.date, week.week, weekday.number, obj.picked));
          }
          week.weekdays.push(obj);
        }
        weeks.push(week);
      }
      return weeks;
    },
    weekdays: function () {
      var abbreviations = Info.weekdays("short", {
        locale: this.locale
      });
      var weekdays = [];
      for (var i = 0; i < abbreviations.length; i++) {
        weekdays.push({
          abbreviation: this.cap(abbreviations[i])
        })
      }
      if (this.firstWeekday > 1) {
        Array.prototype.push.apply(weekdays, weekdays.splice(0, this.firstWeekday - 1));
      }
      for (var j = 0; j < weekdays.length; j++) {
        weekdays[j].number = j + 1;
      }
      return weekdays;
    },
    months: function () {
      var names = Info.months("long", {
        locale: this.locale
      });
      var months = [];
      for (var i = 0; i < names.length; i++) {
        months.push({
          number: i + 1,
          name: this.cap(names[i])
        })
      }
      return months;
    },
    pickYear: function () {
      return this.modeYear || (this.active.year == null && this.active.month == null);
    },
    pickMonth: function () {
      return (!this.pickYear && this.modeMonth) || (this.active.year != null && this.active.month == null);
    },
    pickWeek: function () {
      return !this.pickYear && !this.pickMonth && this.modeWeek && this.active.year != null && this.active.month != null;
    },
    pickDate: function () {
      return !this.pickYear && !this.pickMonth && !this.pickWeek && this.active.year != null && this.active.month != null;
    },
    positionAbsolute: function () {
      return this.position == "absolute";
    },
    positionRelative: function () {
      return this.position == "relative";
    },
    renderButton: function () {
      return this.render == "button";
    },
    renderInput: function () {
      return this.render == "input";
    },
    singleInputClass: function () {
      var cls = "";
      if (this.inputClass) {
        cls += this.inputClass + " ";
      }
      if (this.invalid) {
        cls += "is-invalid ";
      }
      return cls;
    },
    fromInputClass: function () {
      var cls = "";
      if (this.inputClass) {
        cls += this.inputClass + " ";
      }
      if ((this.positionRelative || this.isOpen) && this.rangeFromFocus && !this.rangeToFocus) {
        cls += "focus ";
      }
      if (this.invalid) {
        cls += "is-invalid ";
      }
      return cls;
    },
    toInputClass: function () {
      var cls = "";
      if (this.inputClass) {
        cls += this.inputClass + " ";
      }
      if ((this.positionRelative || this.isOpen) && !this.rangeFromFocus && this.rangeToFocus) {
        cls += "focus ";
      }
      if (this.invalid) {
        cls += "is-invalid ";
      }
      return cls;
    },
    firstLabel: function () {
      if (Array.isArray(this.label)) {
        return this.label[0];
      }
      return this.label;
    },
    secondLabel: function () {
      if (Array.isArray(this.label)) {
        return this.label[1];
      }
      return null;
    },
    firstPlaceholder: function () {
      if (Array.isArray(this.placeholder)) {
        return this.placeholder[0];
      }
      return this.placeholder;
    },
    secondPlaceholder: function () {
      if (Array.isArray(this.placeholder)) {
        return this.placeholder[1];
      }
      return this.placeholder;
    },
    paginationYearSizeBefore: function () {
      return Math.floor(this.paginationYearSize / 3);
    },
    paginationYearSizeAfter: function () {
      return Math.ceil(2 * this.paginationYearSize / 3);
    },
    am: function () {
      if (this.internalValue && this.internalValue instanceof Date) {
        return this.internalValue.hour < 12;
      }
      return true;
    },
    datetimeUtilOptions: function () {
      return {
        includeTime: this.modeDatetime,
        hourFormat: this.hourFormat,
        locale: this.locale
      }
    }
  },
  methods: {
    setActive: function (year, month) {
      this.active.year = year;
      this.active.month = month;
      this.setPaginationYear(year);
    },
    refreshActive: function () {
      if (this.convertedValue) {
        if (this.convertedValue instanceof Date) {
          this.setActive(
              this.convertedValue.year,
              this.convertedValue.month
          );
        } else if (!((this.rangeToFocus || this.rangeFromFocus) && this.modeRange) && Array.isArray(this.convertedValue) && this.convertedValue.length) {
          for (var i = 0; i < this.convertedValue.length; i++) {
            var v = this.convertedValue[i];
            if (v && v instanceof Date) {
              this.setActive(v.year, v.month);
              break;
            }
          }
        }
      } else {
        this.setActive(
            this.active.year ? this.active.year : this.current.year,
            this.active.month ? this.active.month : this.current.month
        );
      }
    },
    refreshPicked: function () {
      if (this.convertedValue) {
        if (Array.isArray(this.convertedValue)) {
          this.picked = this.copyDateArray(this.convertedValue);
        } else if (this.convertedValue instanceof Date) {
          this.picked = this.copyDate(this.convertedValue);
        }
      } else {
        this.picked = null;
      }
    },
    open: function (rangeFocus) {
      if (!this.isOpen && !this.positionRelative) {
        this.refreshActive();
      }
      this.refreshPicked();
      this.rangeFromFocus = rangeFocus == "from";
      this.rangeToFocus = rangeFocus == "to";
      this.isOpen = true;
    },
    close: function () {
      // Refresh here so the shown dates reflect actual value of the component and not the internal cache of the value.
      // Important when you need to click OK to apply changes.
      this.refreshPicked();
      this.isOpen = false;
    },
    ok: function () {
      var newValue = null;
      if (this.modeMultiple && this.picked) {
        if (this.picked.length > 0) {
          newValue = this.copyDateArray(this.picked);
        }
      } else if (this.modeRange && this.picked) {
        if (this.picked.length == 1) {
          newValue = [this.copyDate(this.picked[0]), this.copyDate(this.picked[0])];
        } else if (this.picked.length == 2) {
          newValue = this.copyDateArray(this.picked);
        }
      } else if ((this.modeDate || this.modeDatetime) && this.picked) {
        newValue = this.copyDate(this.picked);
      }
      this.convertedValue = newValue;
      this.close();
    },
    copyDate: function (date) {
      if (date) {
        if (this.modeDatetime) {
          return DateTime.local(date.year, date.month, date.day, date.hour, date.minute, date.second);
        } else {
          return DateTime.local(date.year, date.month, date.day);
        }
      }
      return date;
    },
    copyDateArray: function (array) {
      var newArray = [];
      for (var i = 0; i < array.length; i++) {
        newArray.push(this.copyDate(array[i]));
      }
      return newArray;
    },
    isValidStringDate: function (value) {
      var date = this.getAsDate(value);
      var str = this.getAsString(date);
      return str == value;
    },
    keydownListener: function (event) {
      if (event.keyCode == 27) {
        this.close();
      }
    },
    toCols: function (num, list) {
      var size = Math.ceil(list.length / num);
      var cols = [];
      for (var i = 0; i < num; i++) {
        cols.push(list.slice(i * size, (i * size) + size));
      }
      return cols;
    },
    getWeeksInMonth: function (year, month) {
      var lastDate = this.getLastDateOfMonth(year, month);
      var weeks = [];
      for (var date = 1; date <= lastDate; date += 7) {
        weeks.push(Vue.$datetimeUtil.getWeekNumber(year, month, date, this.firstWeekday));
      }
      var lastWeek = Vue.$datetimeUtil.getWeekNumber(year, month, lastDate, this.firstWeekday);
      if (weeks[weeks.length - 1] != lastWeek) {
        weeks.push(lastWeek);
      }
      return weeks;
    },
    getLastDateOfMonth: function (year, month) {
      return DateTime.local(year, month, 1).plus({months: 1}).plus({days: -1}).day;
    },
    next: function () {
      var active;
      if (this.pickDate || this.pickWeek) {
        active = DateTime.local(this.active.year, this.active.month, 1).plus({months: 1});
        if (active.year <= this.yearMax) {
          this.active.year = active.year;
          this.active.month = active.month;
        }
      } else if (this.pickMonth) {
        active = DateTime.local(this.active.year, 1, 1).plus({years: 1});
        if (active.year <= this.yearMax) {
          this.active.year = active.year;
        }
      } else if (this.pickYear) {
        this.setPaginationYear(this.paginationYear + this.paginationYearSize);
      }
    },
    previous: function () {
      var active;
      if (this.pickDate || this.pickWeek) {
        active = DateTime.local(this.active.year, this.active.month, 1).plus({months: -1});
        if (active.year > this.yearMin) {
          this.active.year = active.year;
          this.active.month = active.month;
        }
      } else if (this.pickMonth) {
        active = DateTime.local(this.active.year, 1, 1).plus({years: -1});
        if (active.year > this.yearMin) {
          this.active.year = active.year;
        }
      } else if (this.pickYear) {
        this.setPaginationYear(this.paginationYear - this.paginationYearSize);
      }
    },
    hoursUp: function () {
      if (this.internalValue && this.internalValue instanceof Date) {
        var date = this.copyDate(this.internalValue);
        var hours = date.hour;
        date.setHours(hours < 23 ? hours + 1 : 0);
        this.internalValue = date;
      }
    },
    hoursDown: function () {
      if (this.internalValue && this.internalValue instanceof Date) {
        var date = this.copyDate(this.internalValue);
        var hours = date.hour;
        date.setHours(hours > 0 ? hours - 1 : 23);
        this.internalValue = date;
      }
    },
    minutesUp: function () {
      if (this.internalValue && this.internalValue instanceof Date) {
        var date = this.copyDate(this.internalValue);
        var minutes = date.minute;
        date.setMinutes(minutes < 55 ? (minutes - (minutes % 5)) + 5 : minutes == 0 ? 55 : 0);
        this.internalValue = date;
      }
    },
    minutesDown: function () {
      if (this.internalValue && this.internalValue instanceof Date) {
        var date = this.copyDate(this.internalValue);
        var minutes = date.minute;
        date.setMinutes(minutes % 5 > 0 ? minutes - (minutes % 5) : minutes == 0 ? 55 : minutes - 5);
        this.internalValue = date;
      }
    },
    formatHour: function (hour) {
      if (hour != null && this.hourFormat == 12) {
        return hour > 12 ? hour - 12 : hour == 0 ? 12 : hour;
      }
      return hour;
    },
    unFormatHour: function (hour) {
      if (hour != null && this.hourFormat == 12) {
        return hour == 12 ? this.am ? 0 : 12 : this.am ? hour : 12 + hour;
        // return this.am ? hour == 12 ? 0 : hour : hour == 12 ? 12 : hour + 12;
      }
      return hour;
    },
    toggleAmPm: function () {
      if (this.hourFormat == 12 && this.internalValue && this.internalValue instanceof Date) {
        var date = this.copyDate(this.internalValue);
        var hours = date.hour;
        if (this.am) {
          hours += 12;
        } else {
          hours -= 12;
        }
        date.setHours(hours);
        this.internalValue = date;
      }
    },
    setPaginationYear: function (year) {
      if (year < this.yearMin) {
        this.paginationYear = this.yearMin;
      } else if (year > this.yearMax - this.paginationYearSizeAfter) {
        this.paginationYear = 1 + this.yearMax - this.paginationYearSizeAfter;
      } else {
        this.paginationYear = year;
      }
    },
    pick: function (year, month, date) {
      var obj = DateTime.local(
          year, month, date,
          this.internalValue && this.internalValue instanceof Date ? this.internalValue.hour : 0,
          this.internalValue && this.internalValue instanceof Date ? this.internalValue.minute : 0);
      // Using this newValue approach because we cannot set internalValue and use it in this method, unless we wait for nextTick.
      var newValue = this.internalValue;
      if (this.modeMultiple) {
        if (!newValue || !Array.isArray(newValue)) {
          newValue = [];
        }
        var removal = false;
        for (var i = 0; i < newValue.length; i++) {
          if (Vue.$datetimeUtil.isSameDate(obj, newValue[i])) {
            removal = true;
            newValue.splice(i, 1);
            break;
          }
        }
        if (!removal) {
          newValue.push(obj);
          newValue.sort(Vue.$datetimeUtil.compareDates);
        }
      } else if (this.modeRange) {
        if (!newValue || !Array.isArray(newValue)) {
          newValue = [];
        }
        // Make sure the length of the array is always 2.
        newValue[0] = newValue[0] ? newValue[0] : null;
        newValue[1] = newValue[1] ? newValue[1] : null;
        var index = this.rangeToFocus ? 1 : 0;
        var newValueBeforeFrom = Vue.$datetimeUtil.isBeforeDate(obj, newValue[0]);
        var newValueAfterTo = Vue.$datetimeUtil.isAfterDate(obj, newValue[1]);
        var duplicate = (index == 1 && newValueBeforeFrom) || (index == 0 && newValueAfterTo);
        if (duplicate) {
          newValue = [obj, obj];
        } else {
          newValue[index] = obj;
        }
        newValue.sort(Vue.$datetimeUtil.compareDates);
        this.rangeFromFocus = this.rangeToFocus;
        this.rangeToFocus = !this.rangeToFocus;
      } else if (this.modeYear || this.modeMonth || this.modeWeek || this.modeDate || this.modeDatetime) {
        newValue = obj;
      }
      this.internalValue = newValue;
    },
    isPicked: function (year, month, date) {
      var obj = DateTime.local(year, month, date);
      if (this.modeMultiple && this.internalValue && Array.isArray(this.internalValue)) {
        if (this.valueMap
            && this.valueMap[year]
            && this.valueMap[year][month]
            && this.valueMap[year][month][date]) {
          return true;
        }
      } else if (this.modeRange && this.internalValue && Array.isArray(this.internalValue)) {
        if (this.internalValue.length == 1) {
          return Vue.$datetimeUtil.isSameDate(obj, this.internalValue[0]);
        } else if (this.internalValue.length == 2) {
          var first = this.internalValue[0];
          var second = this.internalValue[1];
          var both = [first, second];
          both.sort(Vue.$datetimeUtil.compareDates);
          first = both[0];
          second = both[1];
          return Vue.$datetimeUtil.isSameDate(obj, first) || Vue.$datetimeUtil.isSameDate(obj, second) || (Vue.$datetimeUtil.isBeforeDate(obj, second) && Vue.$datetimeUtil.isAfterDate(obj, first));
        }
      } else if ((this.modeDate || this.modeDatetime) && this.internalValue) {
        return Vue.$datetimeUtil.isSameDate(obj, this.internalValue);
      } else if (this.modeWeek && this.internalValue) {
        return obj.year === this.internalValue.year && obj.month === this.internalValue.month && obj.weekNumber == this.internalValue.weekNumber;
      } else if (this.modeMonth && this.internalValue) {
        return obj.year === this.internalValue.year && obj.month === this.internalValue.month;
      } else if (this.modeYear && this.internalValue) {
        return obj.year === this.internalValue.year;
      }
      return false;
    },
    reversedFocus: function () {
      if (this.rangeFromFocus) {
        this.$refs.to.focus();
      } else if (this.rangeToFocus) {
        this.$refs.from.focus();
      }
    },
    zeroPad: function (num, len) {
      var str = "" + num;
      while (str.length < len) {
        str = "0" + str;
      }
      return str;
    },
    validHours: function (hours) {
      return hours >= 0 && hours < this.hourFormat;
    },
    validMinutes: function (minutes) {
      return minutes >= 0 && minutes < 60;
    },
    createCallbackObject: function (year, month, date, week, weekday, picked) {
      return {
        year: year,
        month: month,
        date: date,
        week: week,
        weekday: weekday,
        picked: picked
      };
    },
    showUnselectableReason: function () {
      if (this.unselectableReason) {
        alert(this.unselectableReason);
      }
    },
    cap: function (str) {
      return str.substring(0, 1).toUpperCase() + str.substring(1);
    }
  },
  watch: {
    rangeFromFocus: function (newValue) {
      if (newValue && this.modeRange) {
        var date = this.internalValue[0];
        if (date) {
          this.setActive(date.year, date.month);
        }
      }
    },
    rangeToFocus: function (newValue) {
      if (newValue && this.modeRange) {
        var date = this.internalValue[1];
        if (date) {
          this.setActive(date.year, date.month);
        }
      }
    },
    value: function () {
      this.refreshPicked();
    }
  }
}
</script>

<style lang="less">
@media (max-width: 767px) {
  .w-100-lt-md {
    width: 100% !important;
  }
}
//.position-relative { <--- this one already exists in Bootstrap 5, but it is not responsive
//  position: relative;
//}
//@media (min-width: 576px) {
//  .position-sm-relative {
//    position: relative;
//  }
//}
@media (min-width: 768px) {
  .position-md-relative {
    position: relative;
  }
}
//@media (min-width: 992px) {
//  .position-lg-relative {
//    position: relative;
//  }
//}
//@media (min-width: 1200px) {
//  .position-xl-relative {
//    position: relative;
//  }
//}
//@media (min-width: 1400px) {
//  .position-xxl-relative {
//    position: relative;
//  }
//}
</style>